import { useAuth } from '../contexts/AuthContext.tsx';
import { Layout } from '../components/Layout.tsx';
import { UpdatePassword } from '../components/UpdatePassword.tsx';

export const Configuration: React.FC = () => {
  const { project } = useAuth();

  if (!project) {
    return <div>No project configuration available</div>;
  }

  return (
    <Layout>
      <div className="space-y-6">
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">
          Project Configuration
        </h1>

        <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6 space-y-4 transition-colors">
          <div>
            <h2 className="text-lg font-medium text-gray-900 dark:text-white">
              Basic Information
            </h2>
            <div className="mt-2 grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-400">
                  Project Name
                </label>
                <div className="mt-1 text-gray-900 dark:text-white">
                  {project.name}
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-400">
                  Company Name
                </label>
                <div className="mt-1 text-gray-900 dark:text-white">
                  {project.company?.name}
                </div>
              </div>
            </div>
          </div>

          <div>
            <h2 className="text-lg font-medium text-gray-900 dark:text-white">
              Color Scheme
            </h2>
            <div className="mt-2 grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-400">
                  Primary Color
                </label>
                <div className="mt-1 flex items-center gap-2 text-gray-900 dark:text-white">
                  <div
                    className="w-6 h-6 rounded border dark:border-gray-600"
                    style={{ backgroundColor: project.color_scheme?.primary }}
                  />
                  {project.color_scheme?.primary}
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-400">
                  Secondary Color
                </label>
                <div className="mt-1 flex items-center gap-2 text-gray-900 dark:text-white">
                  <div
                    className="w-6 h-6 rounded border dark:border-gray-600"
                    style={{ backgroundColor: project.color_scheme?.secondary }}
                  />
                  {project.color_scheme?.secondary}
                </div>
              </div>
            </div>
          </div>
        </div>
        <UpdatePassword />
      </div>
    </Layout>
  );
};
